import {
  Component,
  EventEmitter,
  Input,
  NgModule,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import {
  DxCheckBoxModule,
  DxFormComponent,
  DxFormModule,
  DxTagBoxModule,
} from "devextreme-angular";
import { formatMessage } from "devextreme/localization";
import {
  supportedLocales,
  supportedLocalesUs,
} from "src/app/shared/model/supportedLocales";
import { UserFormData } from "../../../model/user/userFormData";
import { CommonModule } from "@angular/common";
import {
  Publisher,
  PublisherGroup,
  Studio,
} from "../../../model/organization/organization";
import {
  EXTENDED_EXTERNAL_USER_ROLES_DE,
  INTERNAL_USER_ROLES_DE,
  AGENCY_EMPLOYEE,
  MANUFACTURER_FOR_PUBLISHER,
  MANUFACTURER_FOR_PUBLISHER_GROUP,
  EXTERNAL_USER_US,
  INTERNAL_USER_US,
  INTERNAL_USER_ROLES_US,
  EXTERNAL_USER_ROLES_US,
} from "../../../model/roles";
import { environment } from "src/environments/environment";
import { ValidationPattern } from "../../../utils/patternUtils";

@Component({
  selector: "app-user-form",
  templateUrl: "./user-form.component.html",
  styleUrls: ["./user-form.component.scss"],
})
export class UserFormComponent implements OnInit {
  @ViewChild(DxFormComponent) form: DxFormComponent;

  formatMessage = formatMessage;
  ValidationPattern = ValidationPattern;

  supportedLocales = supportedLocales;
  supportedLocalesUs = supportedLocalesUs;

  externalUserRolesDe = EXTENDED_EXTERNAL_USER_ROLES_DE;
  internalUserRolesDe = INTERNAL_USER_ROLES_DE;

  externalUserRolesUs = EXTERNAL_USER_ROLES_US;
  internalUserRolesUs = INTERNAL_USER_ROLES_US;

  MANUFACTURER_FOR_PUBLISHER_GROUP = MANUFACTURER_FOR_PUBLISHER_GROUP;
  MANUFACTURER_FOR_PUBLISHER = MANUFACTURER_FOR_PUBLISHER;
  EXTERNAL_USER_US = EXTERNAL_USER_US;
  INTERNAL_USER_US = INTERNAL_USER_US;
  AGENCY_EMPLOYEE = AGENCY_EMPLOYEE;

  isEnvironmentUsa = environment.isUsa;

  @Input() publisherGroups: PublisherGroup[];
  @Input() publisher: Publisher[];
  @Input() studios: Studio[];

  @Input() userData: UserFormData;
  @Output() userDataChange = new EventEmitter<UserFormData>();
  @Output() emailInput: EventEmitter<string> = new EventEmitter<string>();

  constructor() {
    this.translateLocaleValue = this.translateLocaleValue.bind(this);
    this.translateRole = this.translateRole.bind(this);
    this.getPublisherGroupDisplayName =
      this.getPublisherGroupDisplayName.bind(this);
    this.getPublisherDisplayName = this.getPublisherDisplayName.bind(this);
    this.emitEmailInputChange = this.emitEmailInputChange.bind(this);
    this.stayFocused = this.stayFocused.bind(this);
    this.emailComparison = this.emailComparison.bind(this);
  }

  ngOnInit(): void {}

  translateLocaleValue(data): string {
    return formatMessage(`locale.${data}`);
  }

  translateRole(data): string {
    return formatMessage(`user.role.${data}`);
  }

  getPublisherGroupDisplayName(data): string {
    const displayName = data?.displayName ? " (" + data.displayName + ")" : "";

    return data?.disoNumber ? data.disoNumber + displayName : "";
  }

  getPublisherDisplayName(data): string {
    return data?.displayName + " (" + data?.disoNumber + ")";
  }

  resetValues(): void {
    this.form.instance.resetValues();
  }

  isValid(): boolean | undefined {
    return this.form.instance.validate().isValid;
  }

  emitEmailInputChange(e): void {
    this.emailInput.emit(e.event.currentTarget.value);
  }

  stayFocused(e): void {
    setTimeout(() => {
      e.component.focus();
    });
  }

  emailComparison(e) {
    return e.value.toLowerCase() === e.value;
  }
}

@NgModule({
  imports: [DxFormModule, CommonModule, DxCheckBoxModule, DxTagBoxModule],
  declarations: [UserFormComponent],
  exports: [UserFormComponent],
})
export class UserFormModule {}
